import React from "react";

import DeliveryCourierGate from "./DeliveryCourierGate";

export default function DeliveryDashboard() {
  return <DeliveryCourierGate />;
}
